module.exports = __webpack_public_path__ + "img/stamp_gray.2d4594e5.svg";